import { siteText } from './siteText'
import { createContext, useContext, useEffect, useRef, useState, type ReactNode } from 'react'

const ViewActivity = createContext(true)
export const useViewActive = () => useContext(ViewActivity)

/** Retain navigation context without polling or playing media in hidden tabs. */
export function PersistentView({ active, children }: { active: boolean; children: ReactNode }) {
  const [visited, setVisited] = useState(active)
  const element = useRef<HTMLDivElement>(null)
  useEffect(() => {
    if (active) setVisited(true)
    else element.current?.querySelectorAll('video, audio').forEach((media) => (media as HTMLMediaElement).pause())
  }, [active])
  if (!visited && !active) return null
  return <ViewActivity.Provider value={active}><div ref={element} className="persistent-view" hidden={!active}>{siteText(children)}</div></ViewActivity.Provider>
}
